<template>
  <div class="product-nav" :class="[{ sticky: $route.path === '/' }, theme]">
    <nav class="nav navbar-expand">
      <router-link class="navbar-brand" :to="'/'">
        <strong>{{ productInfo.name }}</strong>
      </router-link>
      <div class="collapse navbar-collapse main-links">
        <ul class="list-inline navbar-nav" ref="mainNav">
          <li
            class="list-inline-item"
            v-for="(link, index) in productNav"
            :key="'main-nav-link-' + index"
          >
            <a
              href="javascript:void(0);"
              :ref="`product-link-${index}`"
              v-on:click="animateTo(link.url, $event)"
              class="link"
              :class="[index === 0 ? 'active' : '']"
            >
              {{ link.name }}
            </a>
          </li>
        </ul>
      </div>
      <ul class="list-inline navbar-nav product-info">
        <li class="list-inline-item">
          <template v-if="productInfo.price.reduced">
            <strike>${{ productInfo.price.normal }}</strike>
          </template>
          <template v-else> ${{ productInfo.price.normal }} </template>
        </li>
        <li class="list-inline-item" v-if="productInfo.price.reduced">
          ${{ productInfo.price.reduced }}
        </li>
        <li class="list-inline-item">
          <router-link
            to="/"
            class="btn"
            :class="[theme.includes('dark') ? 'btn-white' : 'btn-black']"
            >Buy Now</router-link
          >
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import gsap from "gsap/dist/gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

export default {
  name: "product-nav",
  computed: {
    productInfo() {
      return this.$store.state.product.info;
    },
    productNav() {
      return this.$store.state.product.productNav;
    },
    theme() {
      return this.$store.state.theme;
    },
  },
  methods: {
    animateTo(id, e) {
      this.$refs.mainNav
        .querySelectorAll("a")
        .forEach((link) => link.classList.remove("active"));
      e.target.classList.add("active");
      gsap.to(window, { duration: 2, scrollTo: id });
    },
  },
};
</script>

<style scoped lang="scss">
.product-nav {
  display: none;
  position: sticky;
  top: 0;
  z-index: 100;
  &::before {
    background-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.3),
      rgba(0, 0, 0, 0)
    );
    display: block;
    content: "";
    width: 100%;
    height: 300px;
    position: absolute;
    top: 0;
    z-index: -1;
  }
  @media screen and (min-width: map-get($grid-breakpoints, lg)) {
    display: block;
  }
  &.theme-dark {
    .navbar-brand,
    .product-info {
      color: #ffffff;
    }
    .link,
    strike {
      color: rgba(255, 255, 255, 0.8);
    }
    .link {
      &.active,
      &:hover {
        color: #ffffff;
      }
    }
  }
  &.theme-light {
    .navbar-brand,
    .product-info {
      color: #000000;
    }
    .link,
    strike {
      color: rgba(255, 255, 255, 0.8);
    }
    .link {
      &.active,
      &:hover {
        color: #000000;
      }
    }
  }
}
.product-info {
  align-items: center;
  font-size: 16px;
  li:not(:last-child) {
    margin-right: 20px;
  }
  li:last-child {
    margin-left: 10px;
    margin-right: 0;
  }
}
nav {
  margin: 0 40px;
  height: 80px;
  align-items: center;
}
.navbar-brand {
  color: #000000;
}
.main-links {
  justify-content: center;
}
strike {
  color: #777;
}
.link {
  font-size: 14px;
  color: #000;
  padding: 10px 14px;
  line-height: 1;
  transition: all 0.5s ease-in-out;
  &:hover {
    text-decoration: none;
  }
  &.active {
    font-weight: bold;
  }
}
</style>
